import HomeIcon from '@mui/icons-material/Home';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box, Container, Grid, Stack } from '@mui/material';
import { motion } from 'framer-motion';
import React from 'react';
import { Link } from 'react-router-dom';
import FeaturesDemoCall from '../component/FeaturesDemoCall';
import PricingPlan from '../component/PricingPlan';

const ACCENT = '#ef6a1d';
const NAVY = '#0b2447';
const NAVY_DEEP = '#061a36';

function Platinumstockfuture() {
  const monthlyPlan = {
    title: 'Monthly',
    price: 'Rs 30000',
    features: [
      '1-2 Intraday Equity signal with set Target & SL.',
      'Follow-up on trade signals.',
      'Morning & Closing Bell update.',
      'Nifty review, Key Resistance & Support point.',
      'Global market & Economic data update.',
      'Stock in News, RBI Policy, IIP, CPI update.',
      '24/7 Customer support',
    ],
  };

  const quarterlyPlan = {
    title: 'Quarterly',
    price: 'Rs  75000',
    features: [
      '1-2 Intraday Equity signal with set Target & SL.',
      'Follow-up on trade signals.',
      'Morning & Closing Bell update.',
      'Nifty review, Key Resistance & Support point.',
      'Global market & Economic data update.',
      'Stock in News, RBI Policy, IIP, CPI update.',
      '24/7 Customer support',
    ],
  };

  const features = [
    { label: 'Minimum Investment', value: '1,00,000' },
    { label: 'Mode of recommendation', value: 'SMS Only' },
    { label: 'Recommendation Frequency', value: '30-45 monthly' },
    { label: 'Follow Up', value: 'Yes, SMS' },
    { label: 'Risk', value: 'High' },
  ];

  const demoCall =
    'Demo call : Buy Reliance fut at 2435 Target 2465 Stoploss 2420';

  return (
    <Box sx={{ overflowX: 'hidden' }}>
      {/* Page Hero */}
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          color: '#fff',
          py: { xs: 7, md: 10 },
          background: `
            radial-gradient(700px 500px at 92% 12%, rgba(239,106,29,0.28) 0%, rgba(239,106,29,0) 60%),
            radial-gradient(600px 500px at 8% 88%, rgba(59,130,246,0.22) 0%, rgba(59,130,246,0) 60%),
            linear-gradient(135deg, ${NAVY_DEEP} 0%, ${NAVY} 50%, #123a73 100%)
          `,
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            inset: 0,
            backgroundImage:
              'linear-gradient(rgba(255,255,255,0.04) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.04) 1px, transparent 1px)',
            backgroundSize: '52px 52px',
            maskImage:
              'radial-gradient(ellipse at center, #000 30%, transparent 80%)',
            WebkitMaskImage:
              'radial-gradient(ellipse at center, #000 30%, transparent 80%)',
            pointerEvents: 'none',
          }}
        />

        <Box
          component="svg"
          viewBox="0 0 1200 240"
          preserveAspectRatio="none"
          sx={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            height: 200,
            opacity: 0.18,
            pointerEvents: 'none',
          }}
        >
          <path
            d="M0 180 C 100 140, 200 160, 300 100 S 500 40, 600 80 S 800 140, 900 90 S 1100 20, 1200 60"
            fill="none"
            stroke={ACCENT}
            strokeWidth="2"
            strokeDasharray="4 8"
          />
          <path
            d="M0 220 C 150 180, 250 200, 400 160 S 600 120, 750 150 S 950 190, 1200 160"
            fill="none"
            stroke="#3b82f6"
            strokeWidth="2"
            strokeDasharray="4 8"
          />
        </Box>

        <Box
          component={motion.div}
          animate={{ y: [0, -18, 0], x: [0, 10, 0] }}
          transition={{ duration: 10, repeat: Infinity, ease: 'easeInOut' }}
          sx={{
            position: 'absolute',
            top: 90,
            right: '8%',
            width: 14,
            height: 14,
            borderRadius: '50%',
            background: ACCENT,
            opacity: 0.7,
            boxShadow: `0 0 32px ${ACCENT}`,
            zIndex: 0,
          }}
        />
        <Box
          component={motion.div}
          animate={{ y: [0, 18, 0], x: [0, -10, 0] }}
          transition={{ duration: 12, repeat: Infinity, ease: 'easeInOut' }}
          sx={{
            position: 'absolute',
            bottom: 90,
            left: '6%',
            width: 10,
            height: 10,
            borderRadius: '50%',
            background: '#3b82f6',
            opacity: 0.7,
            boxShadow: '0 0 28px #3b82f6',
            zIndex: 0,
          }}
        />

        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Box
              component="h1"
              sx={{
                m: 0,
                fontSize: { xs: '2.2rem', sm: '2.8rem', md: '3.6rem' },
                fontWeight: 800,
                lineHeight: 1.1,
                letterSpacing: -1,
                mb: 3,
              }}
            >
              Platinum{' '}
              <Box
                component="span"
                sx={{
                  background: `linear-gradient(90deg, ${ACCENT} 0%, #f59e0b 100%)`,
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                Stock Future
              </Box>
            </Box>

            <Stack
              direction="row"
              alignItems="center"
              spacing={1}
              sx={{
                display: 'inline-flex',
                px: 1.6,
                py: 0.7,
                borderRadius: 5,
                background: 'rgba(255,255,255,0.06)',
                backdropFilter: 'blur(10px)',
                border: '1px solid rgba(255,255,255,0.12)',
                flexWrap: 'wrap',
              }}
            >
              <Box
                component={Link}
                to="/"
                sx={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 0.5,
                  color: '#cbd5e1',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  '&:hover': { color: ACCENT },
                }}
              >
                <HomeIcon sx={{ fontSize: '0.95rem' }} />
                Home
              </Box>
              <KeyboardArrowRightIcon
                sx={{ fontSize: '1rem', color: 'rgba(255,255,255,0.4)' }}
              />
              <Box
                component={Link}
                to="/derivative"
                sx={{
                  color: '#cbd5e1',
                  textDecoration: 'none',
                  fontSize: '0.85rem',
                  fontWeight: 600,
                  '&:hover': { color: ACCENT },
                }}
              >
                Derivative
              </Box>
              <KeyboardArrowRightIcon
                sx={{ fontSize: '1rem', color: 'rgba(255,255,255,0.4)' }}
              />
              <Box sx={{ color: ACCENT, fontSize: '0.85rem', fontWeight: 700 }}>
                Platinum Stock Future
              </Box>
            </Stack>
          </motion.div>
        </Container>
      </Box>

      {/* Content */}
      <Box
        sx={{
          background:
            'linear-gradient(180deg, #fbfcfe 0%, #f1f5f9 60%, #ffffff 100%)',
        }}
      >
        <FeaturesDemoCall features={features} demoCall={demoCall} />

        <Box sx={{ py: { xs: 4, md: 6 } }}>
          <Container maxWidth="lg">
            <Grid
              container
              spacing={3}
              alignItems="stretch"
              justifyContent="center"
              sx={{ maxWidth: 900, mx: 'auto' }}
            >
              <Grid item xs={12} sm={6}>
                <PricingPlan {...monthlyPlan} index={0} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <PricingPlan {...quarterlyPlan} index={1} />
              </Grid>
            </Grid>
          </Container>
        </Box>
      </Box>
    </Box>
  );
}

export default Platinumstockfuture;
